/* Sheet set PDP, variant B behaviour. Everything is delegated or re-applied, because the theme re-renders
   the gallery on colour change and an app relocates inline scripts. */
(function () {
  if (window.__pdpb) return;
  window.__pdpb = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Videos: attach src near the viewport, play muted while visible ---- */
  var canHls = (function () { try { return !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl'); } catch (e) { return false; } })();
  function poster(v) { if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster; }
  function attach(v) {
    poster(v);
    if (v.src) return;
    var src = (canHls && v.dataset.hls) ? v.dataset.hls : v.dataset.src;
    if (src) v.src = src;
  }
  function tryPlay(v) {
    attach(v);
    if (reduce) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var near = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) attach(e.target); });
  }, { rootMargin: '400px' }) : null;
  var nearPoster = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { poster(e.target); nearPoster.unobserve(e.target); } });
  }, { rootMargin: '900px' }) : null;
  var seen = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.muted) tryPlay(v); } else { v.pause(); }
    });
  }, { threshold: 0.4 }) : null;
  function wire(root) {
    (root || document).querySelectorAll('video[data-pdpb]:not([data-wired])').forEach(function (v) {
      v.dataset.wired = '1'; v.muted = true; v.defaultMuted = true; v.playsInline = true;
      if (near) { nearPoster.observe(v); near.observe(v); seen.observe(v); } else { tryPlay(v); }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;

    // Autoplay can be blocked (low power mode, reduced motion): a tap on the video starts it
    var pv = !t.closest('.pdpb-clip') && t.closest('.pdpb-vid video');  // creator clips have their own sound toggle below
    if (pv) { attach(pv); if (pv.paused) pv.play().catch(function () {}); return; }

    // Creator clips: one clip with sound at a time
    var clip = t.closest('.pdpb-clip');
    if (clip) {
      var v = clip.querySelector('video'), b = clip.querySelector('.pdpb-sound'), turnOn = v.muted;
      document.querySelectorAll('.pdpb-clip').forEach(function (f) {
        var ov = f.querySelector('video'), ob = f.querySelector('.pdpb-sound');
        ov.muted = true; ob.setAttribute('aria-label', 'Turn sound on'); ob.classList.remove('is-on');
      });
      if (turnOn) { attach(v); v.muted = false; v.play().catch(function () {}); b.setAttribute('aria-label', 'Turn sound off'); b.classList.add('is-on'); }
      return;
    }

    var arrow = t.closest('[data-pdpb-scroll]');
    if (arrow) {
      var strip = arrow.closest('.pdpb-creators').querySelector('.pdpb-clips');
      strip.scrollBy({ left: strip.clientWidth * 0.8 * (+arrow.dataset.pdpbScroll), behavior: 'smooth' });
      return;
    }

    var pill = t.closest('.pdpb-cmp-pick .pdpb-pill');
    if (pill) {
      var cmp = pill.closest('.pdpb-cmp');
      cmp.dataset.show = pill.dataset.col;
      cmp.querySelectorAll('.pdpb-pill').forEach(function (p) { p.setAttribute('aria-pressed', p === pill); });
      return;
    }

    if (t.closest('[data-pdpb-lab]')) {
      var opener = document.querySelector('[data-lab-open]');
      if (opener) opener.click();
    }
  });

  /* ---- Gallery: droplet loop after the first product photo, overlay chips on items 1 to 3 ---- */
  function cfg() { var el = document.getElementById('pdpb-config'); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function decorate() {
    var c = cfg(); if (!c) return;
    document.querySelectorAll('.product__media').forEach(function (box) {
      if (box.closest('.sticky-atc-bar, .quick-view, [data-quick-view]')) return;
      // Gallery items: product media, our droplet, and the featured images another section injects first
      var isItem = function (el) { return el.matches('[data-product-media-wrapper], .pdpb-drop, .custom-featured-item'); };
      var real = function () { return [].filter.call(box.children, function (el) { return isItem(el) && !el.classList.contains('swiper-slide-duplicate'); }); };
      var media = function () { return real().filter(function (el) { return !el.classList.contains('custom-featured-item'); }); };
      if (!media().length) return;
      var swEl = box.closest('.swiper'), S = swEl && swEl.swiper, looped = !!(S && S.params && S.params.loop);

      // Droplet loop after the first product photo. A looping Swiper keeps cloned slides at both ends,
      // so undo the loop, insert, then rebuild it.
      if (c.video && !box.querySelector(':scope > .pdpb-drop')) {
        if (looped && S.loopDestroy) { try { S.loopDestroy(); } catch (e) {} }
        var first = media()[0], drop = document.createElement('div');
        drop.className = first.className.replace(/\b(hidden|swiper-slide-active|swiper-slide-next|swiper-slide-prev)\b/g, '') + ' pdpb-drop';
        drop.setAttribute('data-pdpb-drop', '');
        drop.innerHTML = '<video data-pdpb data-src="' + c.video + '"' + (c.hls ? ' data-hls="' + c.hls + '"' : '') + (c.poster ? ' poster="' + c.poster + '"' : '') +
          ' muted loop playsinline preload="none" aria-label="' + (c.videoLabel || '') + '"></video>';
        first.after(drop);
        if (S) {
          try {
            if (looped && S.loopCreate) S.loopCreate();
            S.update();
            if (looped && S.slideToLoop) S.slideToLoop(0, 0, false); else S.slideTo(0, 0, false);
          } catch (e) {}
        }
      }

      // Overlay chips on gallery items 1 to 3, featured images included. Swiper clones share
      // data-swiper-slide-index with their original, so map through that.
      var order = real(), bySlide = {};
      order.forEach(function (el, n) { var a = el.getAttribute('data-swiper-slide-index'); if (a !== null) bySlide[a] = n; });
      [].filter.call(box.children, isItem).forEach(function (it) {
        var attr = it.getAttribute('data-swiper-slide-index');
        var i = order.indexOf(it);
        if (i < 0 && attr !== null && attr in bySlide) i = bySlide[attr];
        var text = i >= 0 && i < 3 ? (c.overlays || [])[i] : '';
        var cur = it.querySelector(':scope > .pdpb-ov');
        if (!text) { if (cur) cur.remove(); return; }
        it.classList.add('pdpb-ov-host');
        if (!cur) { cur = document.createElement('span'); cur.className = 'pdpb-ov'; it.appendChild(cur); }
        if (cur.textContent !== text) cur.textContent = text;
      });
    });
    wire();
  }
  var pending = false;
  function schedule() { if (pending) return; pending = true; setTimeout(function () { pending = false; decorate(); wire(); }, 50); }
  function start() {
    var c = cfg();
    if (c && c.badge) { document.documentElement.classList.add('pdpb-badge-on'); }
    schedule();
    // Watch <main>, not the gallery: sibling swatches (Stripes/Polka) swap the whole product section in place,
    // which would leave an observer on the old gallery detached
    var gal = document.querySelector('main') || document.body;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) { if (ms[i].addedNodes.length) { schedule(); return; } }
    }).observe(gal, { childList: true, subtree: true });
  }
  /* ---- Star rating under the title: scroll to the reviews section ----
     The theme's local.js scrolls to the first .animation--section-introduction, which variant B doesn't have,
     so the click did nothing. Capture phase, so ours runs first; delegated, so it survives sibling swaps.
     Lazy media above the reviews grows while we scroll and the header turns sticky, so correct once at the end. */
  function topBar() {
    var el = document.elementFromPoint(window.innerWidth / 2, 2);
    for (; el && el !== document.body; el = el.parentElement) {
      var p = getComputedStyle(el).position;
      if (p === 'fixed' || p === 'sticky') return el.getBoundingClientRect().bottom;
    }
    return 0;
  }
  function reviewsTarget() {
    return document.querySelector('[id$="__pdpb_reviews"]') || document.getElementById('judgeme_product_reviews');
  }
  function goReviews(t, smooth) {
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - topBar() - 12, behavior: smooth ? 'smooth' : 'auto' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.rating-wrapper-scroller');
    if (!a) return;
    var t = reviewsTarget();
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    goReviews(t, !reduce);
    // Keep the reviews pinned while lazy media above them settles (about 2.5s), unless the shopper takes over
    var pinned = true, settled = false, ro = null;
    function realign() {
      if (!pinned || !settled) return;
      if (Math.abs(t.getBoundingClientRect().top - topBar() - 12) > 8) goReviews(t, false);
    }
    function release() {
      pinned = false;
      if (ro) ro.disconnect();
      ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.removeEventListener(ev, release, true); });
    }
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, release, true); });
    if (window.ResizeObserver) { ro = new ResizeObserver(realign); ro.observe(document.body); }
    function onSettled() { if (settled) return; settled = true; realign(); }
    if ('onscrollend' in window) window.addEventListener('scrollend', onSettled, { once: true });
    setTimeout(onSettled, 1200);
    setTimeout(function () { realign(); release(); }, 2500);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
